import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { Moment } from 'moment-timezone';
import { ReactElement } from 'react';
import { S_CollapseSection } from '../../../../../design/sections/collapseSection/S_CollapseSection';
import { GeneralStatsTableContainer } from './table/GeneralStatsTable.container';

interface IProps {
  endDate: Moment;
  startDate: Moment;
}

export const GeneralSection = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { startDate, endDate } = props;
  const subtitle = `(${startDate.format('DD MMMM yyyy')} - ${endDate.format('DD MMMM yyyy')})`;
  return (
    <S_CollapseSection
      title={t('projects.details.stats.general.section_title')}
      subtitle={subtitle}
    >
      <GeneralStatsTableContainer />
    </S_CollapseSection>
  );
});
